module.exports = __webpack_public_path__ + "img/mayu.574030b2.png";